import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

import { GoogleLocationModalComponent } from '@teem/store-module/modals/google-location-modal/google-location-modal.component';
import { StoreInformationService } from '@teem/services/store-information.service';
import { SharedDataService } from '@teem/services/shared-data.service';
import { LoaderService } from '@teem/services/loader.service';
import { uniqueSlugValidator } from '@teem/app/core/utils/email-unique.validator';

import { messages as i18n } from '@teem/constants/messages';
import { category as CategoryApi } from '@teem/constants/api';

import { STORE_TYPE } from '@teem/core/constants/defaults';
import { fileNameFromUrl } from '@teem/helpers/functions';
import { CITY, SAUDI_ARABIA } from '@teem/core/constants/country';
import { environment } from '@teem/environments/environment';
import { country as CountryApi } from '@teem/core/constants/api';
import Survicate from '@survicate/survicate-web-package/survicate_widget';

declare var $: any;
// const baseUrl = environment.baseUrl;
@Component({
  selector: 'service-information',
  templateUrl: './service-information.component.html',
  styleUrls: ['./service-information.component.scss']
})
export class ServiceInformationComponent implements OnInit {
  readonly CITY: any = CITY;
  @ViewChild('logoFile') myPond: any;

  @Output() onBusinessTypeChange: EventEmitter<any> = new EventEmitter();
  @Input() myStoreType;
  serviceCategoriesApi: string = CategoryApi.serviceCategoriesList;
  basicInfo: any;
  storeUrl: any;
  storeInformationForm: FormGroup;
  storeInfo: any = {};
  isSubmitted: boolean = false;
  coverImageFile: any = null;
  coverImageUrl: any = '';
  selectedServiceCategories: Array<any> = [];
  shopStatus: any;
  autoAccept: any;
  cities: any = '';
  countryListApi: string = CountryApi.endPoint;
  cityListApi: string = CountryApi.cities;
  selectedCountry: any;
  selectedCity: any;
  activeTab = 'general';
  outsideSA: boolean = true;

  // Ref: https://pqina.nl/filepond/docs/patterns/api/server/
  uploadToServer = {
    process: (fieldName, file, metadata, load, error, progress, abort) => {
      let oldFileName = this.coverImageUrl ? fileNameFromUrl(this.coverImageUrl) : null;
      let timer;
      if (oldFileName != file.name) {
        // Create data object containing the file and the file metadata
        const formData = new FormData();
        formData.append('logo_image', file, file.name);
        formData.append('store_type',STORE_TYPE.SERVICE);
        formData.append(fieldName, JSON.stringify(metadata));

        this.storeInformationService.uploadFile(formData).subscribe(
          (data) => { console.log(data); },
          (err) => { console.error(`File Upload Error: ${err.message}`); },
        );
        // Progress indicator supported, set progress to 25% of 1
        progress(true, 0.25, 1);
        // Fake completion after 1 second
        timer = setTimeout(() => {
          load(file); // or { body: 'unique-file-id' }
        }, 1000);
      } else {
        load(this.coverImageUrl);
        progress(false);
      }

      // Should expose an abort method so the request can be cancelled by the user
      return {
        abort: () => {
          // abort your request here (we clear timer for demo purposes)
          clearTimeout(timer);
          // updates FilePond interface
          abort();
        }
      };
    },

    revert: (uniqueFileId, load, error) => {
      // remove file from server here
      this.storeInformationService.removeFile(STORE_TYPE.SERVICE).subscribe(
        (data) => {
          console.log(data);
          load();
        },
        (err) => { console.error(`Remove File Upload Error: ${err.message}`); },
      );
      console.log("deleted  ", uniqueFileId);
    }
  };

  pondOptions = {
    multiple: false,
    // allowRevert: false,
    allowReplace: false,
    allowRemove: true,
    allowImageResize: true,
    allowImagePreview: true,
    // labelIdle: `
    // <div style="text-align: center">
    // 	<p>${i18n.drag_and_drop_file}</p>
    // </div>`,
    imageResizeMode: 'cover',
    imagePreviewHeight: 300,
    imagePreviewMinHeight: 300,
    imagePreviewMaxHeight: 300,
    imageResizeTargetWidth: 700,
    imageResizeTargetHeight: 300,
    server: this.uploadToServer,
    acceptedFileTypes: 'image/png, image/jpeg, image/gif',
    labelIdle: `<span class="icon-upload"></span>`,
    beforeRemoveFile: this.pondHandleRemoveFile,
  };

  constructor(
    private formBuilder: FormBuilder,
    private storeInformationService: StoreInformationService,
    private loaderService: LoaderService,
    private sharedDataService: SharedDataService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer
  ) {
    this.createStoreFormGroup();
  }

  pondHandleInit() {
    console.log('FilePond has initialised', this.myPond);
  }

  pondHandleAddFile(event: any) {
    console.log('A file was added', event);
  }

  async pondHandleRemoveFile(event: any) {
    let confirm = await Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.store.delete_cover_image_confirm,
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: i18n.yes,
      cancelButtonText: i18n.no_cancel_it
    })
    if (confirm.isConfirmed) {
      return true
    }
    return false;
  }

  ngOnInit(): void {
    this.basicInfo = (window as any).userInfo;
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        Survicate.init({
          workspaceKey: environment?.survicate_key,
          disableTargeting: true,
          traits: {
            id: data?.userInfo?.id,
            email: data?.userInfo?.email
          }
        });
        this.basicInfo = data.userInfo;
        this.storeInformationForm.get('name').setValue(this.basicInfo.business_name);
        this.storeInformationForm.get('phone').setValue(this.basicInfo.phone);
      }
    })
    this.fetchStoreInfo();
  }

  convertToSlug(input: string) {
    let slug = input.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
    this.storeInformationForm.get('slug').setValue(slug);
    this.storeUrl = `${environment.baseUrl}/services/${this.storeInformationForm.get('slug').value}`;
  }

  fetchStoreInfo() {
    this.loaderService.startLoading();

    this.storeInformationService.getServiceInfo().subscribe((data: any) => {
      if (!data.error) {
        this.storeInfo = data;
        this.storeInformationForm.patchValue(data);
        this.coverImageUrl = this.storeInfo.cover_image;
        if (data.service_categories) {
          this.selectedServiceCategories = data.service_categories.map((item) => item.name);
        }
        // if (data.additional_information.length) {
        //   this.storeInformationForm.get('allow_additional_info').setValue(1);
        //   const controlArray = this.additionalInfo;
        //   data.additional_information.forEach((app) => {
        //     const aif = this.newInfo();
        //     aif.patchValue(app);
        //     controlArray.push(aif);
        //   });
        //   this.deleteAdditionalInfo(0);
        // }else {
        //   $("#checkbox-002").slideToggle();
        //   $("#additioanl-information").hide();
        //   this.storeInformationForm.get('allow_additional_info').setValue(0);
        // }
        this.storeInformationForm.get('allow_additional_info').setValue(data.allow_additional_info);
        this.shopStatus = data.active === 0 ? false : true;
        this.autoAccept = data.auto_accept === 0 ? false : true;
        if (data.slug){
          this.storeUrl = `${environment.baseUrl}/services/${data.slug}`;
        }

        if (data.country_id == SAUDI_ARABIA) {
          this.outsideSA = false;
        }

        if (data.country_id) {
          this.selectedCountry = {
            id: data.country_id,
            country_name: data.country_name
          }
          this.storeInformationForm.get('country_id').setValue(SAUDI_ARABIA);
          this.onChangeCountry(this.selectedCountry);
        }
        if (data.city_id) {
          this.selectedCity = {
            id: data.city_id,
            name: data.city_name
          }
          this.storeInformationForm.get('city_id').setValue(data.city_id);
        }

        if (!data.shop_comments) {
          this.storeInformationForm.get('allow_shop_comment').setValue(0);
          $("#checkbox-005").slideToggle();
          $("#shop-comments").hide();
          let shop_comments = this.storeInformationForm.get('shop_comments');
          shop_comments.setValue(null);
          shop_comments.setValidators([]);
          shop_comments.updateValueAndValidity();
        } else{
          this.storeInformationForm.get('allow_shop_comment').setValue(1);
        }

        setTimeout(function () {
          $('select[nice-select]').niceSelect('update');
        }, 1000);
      }
      this.loaderService.stopLoading();
    }, err => {
      this.loaderService.stopLoading();
    });
  }


  createStoreFormGroup() {
    this.storeInformationForm = this.formBuilder.group({
      name: [null, Validators.required],
      slug: [null, [Validators.required], [uniqueSlugValidator(this.storeInformationService, 'service')] ],
      phone: [null, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(5), Validators.maxLength(30)]],
      whatsapp_phone: [null, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(5), Validators.maxLength(30)]],
      shop_type: [STORE_TYPE.SERVICE],
      postcode: [null],
      description: [null],
      terms_conditions: [null],
      privacy_policy: [null],
      cover_image: [null],
      customer_additional_info: [null],
      allow_outside_of_city: [null],
      additional_info: this.formBuilder.array([
        this.newInfo()
      ]),
      service_categories: [[]],
      allow_shop_comment:[0],
      shop_comments: [null],
      upload_reference_files:[0],
      allow_additional_info:[1],
      accept_inside_ksa:[0],
      accept_outside_ksa:[0],
      address: [null],
      pin_drop_location: [null],
      country_id: [null, Validators.required],
      city_id: [null],
      city_name: [null],
    });
  }

  get f() {
    return this.storeInformationForm.controls;
  }

  get additionalInfo() {
    return this.storeInformationForm.get('additional_info') as FormArray;
  }

  newInfo(): FormGroup {
    return this.formBuilder.group({
      information: [null],
      make_mandatory: [null],
    })
  }

  addAdditionalInfo() {
    this.additionalInfo.push(this.newInfo());
  }

  deleteAdditionalInfo(index) {
    this.additionalInfo.removeAt(index);
  }

  getInformationFormGroup(index) {
    return this.additionalInfo.controls[index] as FormGroup;
  }

  onChangeCountry(item) {
    let countryId = item.id;
    let cityId = this.storeInformationForm.get('city_id');
    let cityName = this.storeInformationForm.get('city_name');
    if (countryId == 682) {
      this.outsideSA = false;
      this.loaderService.startLoading();
      this.storeInformationService.getKSACities().subscribe((data: any) => {
        this.cities = data;
        this.loaderService.stopLoading();
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
      // cityId.setValidators([Validators.required]);
      // cityId.setValue(cityId.value);
      // cityName.clearValidators();
      cityName.setValue(null);
    }
    else {
    //   cityName.setValidators([Validators.required]);
    //   cityName.setValue(cityName.value);
    //   cityId.clearValidators();
      cityId.setValue(null);
      this.outsideSA = true;
    }
    // cityId.updateValueAndValidity();
    // cityName.updateValueAndValidity();
  }

  toggleSildes(event) {
    $("#" + event.target.attributes["tm-toggle"].value).slideToggle();
  }

  allowShopComments(event) {
    let shop_comments = this.storeInformationForm.get('shop_comments');
    console.log('event.target.checked')
    console.log(event.target.checked)
    if (event.target.checked) {
      shop_comments.setValidators([Validators.required]);
    } else {
      shop_comments.setValue(null);
      shop_comments.setValidators([]);
    }
    shop_comments.updateValueAndValidity();
  }

  makeMandatory(index, event) {
    const information = this.additionalInfo.controls[index].get('information');
    if (event.target.checked) {
      information.setValidators([Validators.required]);
    } else {
      information.clearValidators();
    }
    information.updateValueAndValidity();
  }

  onUnselectServiceCategory(data: any) {
    if (this.storeInfo && this.storeInfo.associated_service_categories) {
      if (this.storeInfo.associated_service_categories.indexOf(data.item.name) !== -1) {
        data.event.preventDefault();
        Swal.fire(i18n.error.cant_delete_category, i18n.error.category_associated_with_service, 'error');
      }
    }
  }

  formatSelection(item: any) {
    let dayShortName = item.value.substring(0, 3);
    return dayShortName.replace(/\b\w/g, l => l.toUpperCase()) + ',';
  }

  getAllErrors(form: FormGroup | FormArray): { [key: string]: any; } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce((acc, key) => {
      const control = form.get(key);
      const errors = (control instanceof FormGroup || control instanceof FormArray) ? this.getAllErrors(control) : control.errors;
      if (errors) {
        acc[key] = errors;
        hasError = true;
      }
      return acc;
    }, {} as { [key: string]: any; });
    return hasError ? result : null;
  }


  onSubmit() {
    this.isSubmitted = true;
    if (this.storeInformationForm.valid) {

      let fd = this.storeInformationForm.value;

      if (this.coverImageFile) {
        fd.cover_image = this.coverImageFile;
      }

      if (!this.coverImageUrl) {
        fd.delete_cover_image = true;
      }

      fd.upload_reference_files = fd.upload_reference_files ? 1 : 0;
      fd.accept_inside_ksa = fd.accept_inside_ksa ? 1 : 0;
      fd.accept_outside_ksa = fd.accept_outside_ksa ? 1 : 0;
      fd.active = this.shopStatus ? 1 : 0;
      fd.auto_accept = this.autoAccept ? 1 : 0;
      this.loaderService.startLoading();

      // this.storeInformationService.updateServiceInfo(fd, { headers: { 'Content-Type': 'multipart/form-data' } })
      this.storeInformationService.updateServiceInfo(fd, { headers: { 'Content-Type': 'multipart/form-data' } })
        .subscribe(
          (res) => {
            this.loaderService.stopLoading();

            let userInfo = this.sharedDataService.getItem('userInfo');
            userInfo.has_store = true;
            this.sharedDataService.setItem('userInfo', userInfo);
            Survicate.showSurvey(environment?.survey?.storefront, { forceDisplay: true });
            Swal.fire(i18n.done, i18n.store.updated, 'success'); //'Store information updated'
          },
          (err) => {
            this.loaderService.stopLoading();
            if (err.status === 422) {
              if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
                let validationErrors = err.error.errors;
                Object.keys(validationErrors).forEach((prop) => {
                  this.storeInformationForm.get(prop)?.setErrors({
                    serverError: validationErrors[prop]
                  })
                })
              }
            }
            
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          }
        )
      this.isSubmitted = false;
    }
  }

  openGoogleMap() {
    const modalRef = this.modalService.open(GoogleLocationModalComponent, {
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
    });

    modalRef.result.then(result => {
      this.storeInformationForm.get('pin_drop_location').setValue(result.marker);
      this.storeInformationForm.get('address').setValue(result.address);
      console.log('result', result);
    }, fallbackResult => {

    })
  }

  copyLink(inputElement?: any) {
    try {
      inputElement.select();
      (document as any).execCommand('copy');
      inputElement.setSelectionRange(0, 0);

      Swal.fire(i18n.done, 'Link copied', 'success');
    } catch (err) {
      console.error(err);
    }
  }

  copyText() {
    try {
      let selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = this.storeUrl;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      Swal.fire(i18n.done, 'Link copied', 'success');
    } catch (err) {
      console.error(err);
    }
  }

  tabChange(tab) {
    this.isSubmitted = true;
    // if (this.storeInformationForm.valid) {
    //   this.activeTab = tab;
    // }
    if (this.activeTab == 'general') {
      if (
        this.storeInformationForm.get('name').valid &&
        this.storeInformationForm.get('slug').valid &&
        this.storeInformationForm.get('phone').valid &&
        this.storeInformationForm.get('whatsapp_phone').valid &&
        this.storeInformationForm.get('shop_type').valid &&
        this.storeInformationForm.get('postcode').valid &&
        this.storeInformationForm.get('description').valid &&
        this.storeInformationForm.get('cover_image').valid &&
        this.storeInformationForm.get('customer_additional_info').valid &&
        this.storeInformationForm.get('allow_outside_of_city').valid &&
        this.storeInformationForm.get('additional_info').valid &&
        this.storeInformationForm.get('service_categories').valid &&
        this.storeInformationForm.get('allow_shop_comment').valid &&
        this.storeInformationForm.get('shop_comments').valid &&
        this.storeInformationForm.get('upload_reference_files').valid &&
        this.storeInformationForm.get('allow_additional_info').valid &&
        this.storeInformationForm.get('accept_inside_ksa').valid &&
        this.storeInformationForm.get('accept_outside_ksa').valid &&
        this.additionalInfo.valid
      ) {
        this.activeTab = tab;
      } else {
        this.markFieldsAsTouched(['name','slug','phone','whatsapp_phone','shop_type','postcode','description','cover_image','customer_additional_info','allow_outside_of_city','additional_info','service_categories','allow_shop_comment','shop_comments','upload_reference_files','allow_additional_info','accept_inside_ksa','accept_outside_ksa']);
      }
    }

    if (this.activeTab == 'store-address') {
      if (
        this.storeInformationForm.get('address').valid &&
        this.storeInformationForm.get('pin_drop_location').valid &&
        this.storeInformationForm.get('country_id').valid &&
        this.storeInformationForm.get('city_id').valid &&
        this.storeInformationForm.get('city_name').valid
      ) {
        this.activeTab = tab;
      } else {
        this.markFieldsAsTouched(['address','pin_drop_location','country_id','city_id','city_name']);
      }
    }
  }

  markFieldsAsTouched(fields: string[]) {
    fields.forEach(field => {
      this.storeInformationForm.get(field)?.markAsTouched();
    });
  }

}
